const state = {
  isOnline: navigator.onLine,
  isMobile: false,
};

const mutations = {
  setOnline(state, value) {
    state.isOnline = value;
  },
  setMobile(state, value) {
    state.isMobile = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
